import { FC } from 'react'

export const IconOutOfGaugeTriangles: FC<{ zoom?: number; size?: number }> = ({ zoom, size }) => {
  return (
    <svg
      width={size ?? '32'}
      height={size ?? '32'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: `scale(${(zoom ?? 100) / 100})` }}
    >
      <rect x='5.7002' y='5.77051' width='8.6' height='8.72973' stroke='#919EAB' />
      <path d='M10.0002 0L14.1571 4.56081H5.84327L10.0002 0Z' fill='#637381' />
      <path d='M20 10.1354L15.5 14.3485L15.5 5.92228L20 10.1354Z' fill='#637381' />
      <path
        d='M-5.24537e-07 10.1351L4.5 5.92204L4.5 14.3482L-5.24537e-07 10.1351Z'
        fill='#637381'
      />
    </svg>
  )
}

export default IconOutOfGaugeTriangles
